import React from 'react'

import type { Track } from 'types/track'

import { Flex, Text } from 'components/ds'

import ContentTracksGrid, { type ContentType } from './components/track-grid'

type ContentTracksProps = {
  tracks: Track[]
  contentType: ContentType
  contentId: number
  contentName?: string
  businessName?: string
  isLoading: boolean
  error?: string | null
  contentBusinessId?: number
}

const ContentTracks = ({
  tracks,
  contentType,
  contentId,
  contentName,
  businessName,
  isLoading,
  error,
  contentBusinessId,
}: ContentTracksProps): React.ReactNode => {
  if (error) {
    return (
      <Flex direction="column" align="center" justify="center" py="6">
        <Text size="2" color="gray">
          {error}
        </Text>
      </Flex>
    )
  }

  if (!isLoading && tracks.length === 0) {
    return (
      <Flex direction="column" align="center" justify="center" py="6">
        <Text size="2" color="gray">
          No tracks available.
        </Text>
      </Flex>
    )
  }

  return (
    <ContentTracksGrid
      tracks={tracks}
      contentType={contentType}
      contentId={contentId}
      contentName={contentName}
      businessName={businessName}
      isLoading={isLoading}
      contentBusinessId={contentBusinessId}
    />
  )
}

export default ContentTracks
